module.exports = __webpack_public_path__ + "img/Patch23-1.8b89b899.webp";